import type { DashboardConfig } from '../config';
import { clusterBase } from '../clusterBase';

/*
 * "Système U — Minions — Pinball" (Coopérative U, program su04, "Mission
 * Incognito"): one free pinball game a day in the MonMagasinU app, extra games
 * from the login and invite missions, a lottery ticket per game and a top-20
 * leaderboard. One period, Tue 3 Nov 09:00 → Sun 6 Dec 2026, Paris time
 * (Minions Project Passport, mg1–mg4; prod settings, 2 Nov).
 *
 * Its own payload shape and page (features/minions), so `kind: 'minions'`.
 */
export const systemeUMinionsConfig: DashboardConfig = {
  path: '/systeme-u/minions',
  reportId: 'systeme-u-minions-2026',
  label: 'Système U · Minions',
  endsOn: '2026-12-06', // 3 Nov → 6 Dec — archived from the day after
  kind: 'minions',
  // Prod backend is mngs03 on the EU cluster (passport, "Domains").
  apiBaseUrl: clusterBase('eu'),
};
